// extracted by mini-css-extract-plugin
module.exports = {"digits":"criticReview__digits--DKVQS","large":"criticReview__large--3mzCL","max":"criticReview__max--VQEaj"};